import script from "./ModalVincularPerfilTpDoc.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalVincularPerfilTpDoc.vue?vue&type=script&setup=true&lang=js"

import "./ModalVincularPerfilTpDoc.vue?vue&type=style&index=0&id=cdb157c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cdb157c0"]])

export default __exports__